// Single source of truth for mapping a project's ``currency_code`` to a
// display symbol. UK sites are GBP (£), Netherlands sites are EUR (€);
// a null / unknown code defaults to £ (the FE default until a site is
// linked + refreshed from BMA). Every surface that renders project money
// - the Project-data cost fields, the Procurement tab, the projects-list
// EPC cost/kWp chip - reads its symbol from here so they can't drift.

export type CurrencyCode = "GBP" | "EUR";

export const currencyCodeOf = (code: string | null | undefined): CurrencyCode =>
  code === "EUR" ? "EUR" : "GBP";

export const currencySymbol = (code: string | null | undefined): string =>
  currencyCodeOf(code) === "EUR" ? "€" : "£";
